import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { browserRefresh } from 'projects/b2c/src/app/app.component';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { SwalService } from 'projects/b2c/src/app/core/services/swal.service';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { ThemeOptions } from 'projects/b2c/src/app/theme-options';
import { SubSink } from 'subsink';
import { Logger } from '../../../../core/logger/logger.service';
import { HotelService } from '../../hotel.service';
import { HotelSearchLoaderComponent } from './components/hotel-search-loader/hotel-search-loader.component';
import { AppGlobal } from 'projects/b2c/src/app/app.global';
import { Subscription } from 'rxjs';

declare var $: any;
const log = new Logger('hotel/HotelResultsComponent')

@Component({
	selector: 'app-hotel-results',
	templateUrl: './hotel-results.component.html',
	styleUrls: ['./hotel-results.component.scss']
})
export class HotelResultsComponent implements OnInit, OnDestroy {

	@ViewChild('mapContainer', { static: true }) gMap: ElementRef<HTMLDivElement>;
	selectedHotel
	map: google.maps.Map;
	searchType = "middle";
	traveller: any;
	travellerAdult: any = 0;
	travellerChild: any = 0;
	checkInDate: any;
	checkOutDate: any;
	destination: any;
	searchPayload: any;
	protected subs = new SubSink();
	loading: boolean;
	hotels: any = [];
	errorMessage: any;
	isCollapsed = true;
	isCollapsedSearch = true;
	showMobilefilter = true;
	mobileModify: boolean = false;
	serverError = false;
	noHotel = false;
	searchingHotel = false;
	primaryColour: any;
	secondaryColour: any;
	loadingTemplate: any;

	noHotelMessage: any;
	browserRefresh: boolean;
	cityData: any;
	coordinates: any;
	lat: number;
	lng: number;
	marker: google.maps.Marker;
	details: any = {};
	mapLoaded: Promise<boolean>;
	onShownSubscription: Subscription | null = null;
	mapInitialized = false;

	constructor(
		private ngxService: NgxUiLoaderService,
		private hotelService: HotelService,
		private router: Router,
		public globals: ThemeOptions,
		private cd: ChangeDetectorRef,
		private dialog: MatDialog,
		private apiHandlerService: ApiHandlerService,
		private util: UtilityService,
		private appGlobal: AppGlobal,
		private swalService: SwalService,
	) {
	}

	ngOnInit(): void {
		this.searchPayload = this.prepareSearchPayloadFromSessionData('hotelSearchData');
		this.browserRefresh = browserRefresh;
		if (this.browserRefresh) {
			this.hotelService.formFilled.next(JSON.parse(sessionStorage.getItem('hotelSearchData')));
		}

		this.clearAdultChildCount();
		this.searchPayload.RoomGuests.forEach(element => {
			this.travellerAdult += element.NoOfAdults;
			this.travellerChild += element.NoOfChild;
			this.traveller = [{
				adults: element.NoOfAdults,
				childrens: element.NoOfChild
			}];
		});
		this.searchResult(this.searchPayload);
		this.hotelService.loading.next(true);
		this.subs.sink = this.hotelService.searchingHotel.subscribe(res => {
			this.searchingHotel = res;
		});
		this.subs.sink = this.hotelService.serverError.subscribe(res => {
			this.serverError = res;
		});
		this.subs.sink = this.hotelService.loading.subscribe(res => {
			this.loading = res;
		});
		this.subs.sink = this.hotelService.hotels.subscribe(res => {
			if (!res.length) {
				this.hotels = [];
				if (res.Message)
					this.dialog.closeAll();
				this.noHotelMessage = res.Message;
			} else {
				this.hotelService.loading.next(false);
				this.hotels = res || [];

				const cityname = this.hotelService.formFilled.value
				this.cityData = cityname.cityName;
				if (!this.loading) {
					setTimeout(_ => {
						this.dialog.closeAll();
						this.globals.sidebarHover = true;
					}, 100);
				}
			}
		});
		this.subs.sink = this.hotelService.changeDetectionEmitter.subscribe(
			() => {
				this.cd.detectChanges();
			},
			(err) => {
				console.log(err);
			}
		);
		this.subs.sink = this.hotelService.isCollapsed.subscribe(res => {
			this.isCollapsed = res;
		});
		this.subs.sink = this.hotelService.noHotel.subscribe(res => {
			this.noHotel = res;
		});
		this.hotelService.loading.next(false);

		this.mobileModify = this.getIsMobile();
		window.onresize = () => {
			this.mobileModify = this.getIsMobile();
			this.isCollapsedSearch = this.getIsMobile();
		};
		console.log("hotels", this.hotels);

	}
	
	  initializeMap(selectedHotel): void {
		this.selectedHotel = selectedHotel
		if (this.selectedHotel.Latitude && this.selectedHotel.Longitude) {
		  const mapOptions = {
			center: new google.maps.LatLng(this.selectedHotel.Latitude, this.selectedHotel.Longitude),
			zoom: 14,
		  };
	
		  this.map = new google.maps.Map(this.gMap.nativeElement, mapOptions);
	
		  const position = new google.maps.LatLng(this.selectedHotel.Latitude, this.selectedHotel.Longitude);
		  const marker = new google.maps.Marker({
			position: position,
			map: this.map,
			title: this.selectedHotel.HotelName,
		  });
		  this.cd.detectChanges();
		  this.placeMarkerInfo(marker);
		} else {
		  console.warn("Hotel location is missing or invalid.");
		}
		this.cd.detectChanges();
	  }
	
	  placeMarkerInfo(marker: google.maps.Marker): void {
		const infowindow = new google.maps.InfoWindow();
		const popupContent = `
		  <div style="width:300px; padding:2px;">
			<div class="mapplot" style="color:#3399FE;">
			  <div class="projimg1" style="float:left;">
				<img src="${this.selectedHotel.HotelPicture}" height="60" width="60">
			  </div>
			  <div class="mapplot_desc">
				<div style="color: royalblue; font-size: 14px; font-weight:bold;">
				  ${this.selectedHotel.HotelName},
				  <small style="color:#000;"> ${this.selectedHotel.HotelAddress}</small>
				</div>
			  </div>
			</div>
		  </div>`;
		infowindow.setContent(popupContent);
		infowindow.open(this.map, marker);
	
		marker.addListener('click', () => {
		  infowindow.open(this.map, marker);
		});
	  }

	getIsMobile(): boolean {

		const w = document.documentElement.clientWidth;
		const breakpoint = 992;
		if (w < breakpoint) {
			this.isCollapsedSearch = false;
			this.showMobilefilter = false;
			return true;
		} else {
			return false;
		}
	}

	mobileFilter() {
		this.showMobilefilter = true;
	}

	closeFilter() {
		this.showMobilefilter = false;
	}

	searchResult(data: any) {
		this.hotelService.formFilled.subscribe(d => {
			if (!this.util.isEmpty(d)) {
				const params = d;
				if (params) {
					console.log("params", params)
					this.clearAdultChildCount();
					this.traveller = params['traveller'];
					this.traveller.forEach(element => {
						this.travellerAdult += element.adults;
						this.travellerChild += element.childrens;
					});
					this.checkInDate = moment(params['checkin']).format('YYYY-MM-DD');
					this.checkOutDate = moment(params['checkout']).format('YYYY-MM-DD');
					this.destination = params['cityName'];
					let config = new MatDialogConfig();
					config.height = '600px';
					config.width = '1000px';
					config.panelClass = "copy-items-modal";
					config.disableClose = true;
					config.data = {
						data: this.hotelService.formFilled.value
					}
					let copyDialog = this.dialog.open(HotelSearchLoaderComponent, config);
				}
			}
		})
		this.hotelService.searchResult(data);
		this.cd.detectChanges();
	}

	private prepareSearchPayloadFromSessionData(sessionKey: string): any {
		const ssd = JSON.parse(sessionStorage.getItem(sessionKey));
		if (!ssd) {
			this.router.navigate(['/']);
		}
		let RoomGuests = [];
		this.clearAdultChildCount();
		ssd['traveller'].forEach(element => {
			this.setAdultChildCount(element);
			RoomGuests.push({
				"NoOfAdults": Number(element['adults']),
				"NoOfChild": Number(element['childrens']),
				"ChildAge": element['childAges']
			})
		});

		let reqBody = {
			"CheckIn": `${(moment(ssd['checkin'])).format('YYYY-MM-DD')}`,
			"CheckOut": `${moment(ssd['checkout']).format('YYYY-MM-DD')}`,
			"Currency": this.appGlobal.selectedCurrency.value,
			"Market": ssd['market'],
			"CancellationPolicy": true,
			"CityIds": [
				`${ssd['destination_id']['cityId']}`
			],
			rate: ssd['rate'] ? Number(ssd['rate']) : null,
			fromPrice: Number(ssd['fromPrice']),
			toPrice: Number(ssd['toPrice']),
			NoOfRooms: Number(ssd['traveller'].length),
			RoomGuests,
			booking_source: `${ssd['destination_source']}`
		}
		return reqBody;
	}

	onBookNow(hotel: any) {
		this.hotelService.loading.next(true);
		this.subs.sink = this.apiHandlerService.apiHandler('hotelDetails', 'POST', '', '', {
			ResultToken: hotel.ResultIndex,
			booking_source: hotel.booking_source,
			UserId: 0,
			UserType: "B2C"
		}).subscribe(res => {
			if (res.data.length > 0 || res.data) {
				this.hotelService.bookingHotelData.next(res.data);
				localStorage.setItem('bookingHotelData', JSON.stringify(this.hotelService.bookingHotelData.getValue()));
				this.hotelService.resultToken = res.ResultToken;
				this.hotelService.traveller = this.traveller;
				localStorage.setItem('hotelTraveller', JSON.stringify(this.hotelService.traveller));
				this.router.navigate(['/hotel-booking']);
			} else {
				this.hotelService.loading.next(false);
				this.swalService.alert.oops(res.Message)
			}
			this.hotelService.loading.next(false);
		});
	}

	hasAmenities(amenitiesArr: Array<any>, type: string): boolean {
		const amenitiesStr = amenitiesArr.join('').replace(/_/gi, '').toLowerCase();
		const typeArr = type.toLowerCase().replace(/_/gi, '').split('|');
		let found: boolean = false;
		typeArr.forEach(matchStr => {
			const match = new RegExp(`${matchStr}`, 'gi');
			if (amenitiesStr.match(match)) {
				found = true
			}
		});
		return found;
	}
	resetFilter() {
		this.hotelService.resetFilter();
	}

	getStarArray(num) {
		num = Number(num);
		let starArr = [];
		if (num && num >= 0)
			starArr.length = Math.round(num);
		console.log("starArr", starArr)
		return starArr;
	}

	getStarArrayRemaining(num) {
		num = Number(num);
		let starArr = [];
		if (num && num >= 0)
			starArr.length = 5 - Math.round(num);
		return starArr;
	}

	setAdultChildCount(element) {
		this.travellerAdult += Number(element['adults']);
		this.travellerChild += Number(element['childrens']);
	}

	clearAdultChildCount() {
		this.travellerAdult = 0;
		this.travellerChild = 0;
	}

	ngOnDestroy(): void {

		if (this.onShownSubscription) {
			this.onShownSubscription.unsubscribe();
		}
	}

}
